import * as React from "react";

import type { DesignaliProps } from "../../types";

export const SeparatorVertical = React.forwardRef<
  SVGSVGElement,
  DesignaliProps
>(({ ...props }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
      ref={forwardedRef}
    >
      <line x1="12" x2="12" y1="3" y2="21" />
      <polyline points="8 8 4 12 8 16" />
      <polyline points="16 16 20 12 16 8" />
    </svg>
  );
});

export default SeparatorVertical;
